import { Component, OnInit, ViewChild } from "@angular/core";
import { MapInfoWindow, MapMarker, GoogleMap } from "@angular/google-maps";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { ActivatedRoute, Router } from "@angular/router";
import { SessionService } from "../../services/session.service";
import { environment } from "../../../environments/environment";
import Swal from "sweetalert2";
import { UtilityService } from "src/app/services/utility.service";
import * as $ from "jquery";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";

@Component({
  selector: "app-locatestore",
  templateUrl: "./locatestore.component.html",
  styleUrls: ["./locatestore.component.css"],
})
export class LocatestoreComponent implements OnInit {
  @ViewChild(GoogleMap, { static: false }) map: GoogleMap;
  @ViewChild(MapInfoWindow, { static: false }) info: MapInfoWindow;

  zoom = 12;
  center: google.maps.LatLngLiteral;
  options: google.maps.MapOptions = {
    // zoomControl: true,
    // scrollwheel: true,
    // disableDoubleClickZoom: true,
    // mapTypeId: 'hybrid',
    maxZoom: 15,
    minZoom: 3,
  };
  markers = [];
  config: any;
  currentPageLength: any = 10;
  searchObject: any = {};
  results: any;
  infoContent = "";
  collectionCenters: any;
  lgas: any;
  apiUrl: string;
  searchForm: FormGroup;
  submitted = false;

  constructor(
    private formBuilder: FormBuilder,
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute,
    private utility: UtilityService,
    private sess: SessionService,
    private spinnerService: Ng4LoadingSpinnerService
  ) {}

  ngOnInit(searchObj = null) {
    if (searchObj == null || searchObj == "") {
      this.collectionCenters = "";
      this.initialiseForm();
      console.log("searchObj is null");
    } else {
      this.collectionCenters = "";
      console.log("searchObj is not null");
    }

    this.config = {
      currentPage: 1,
      itemsPerPage: 10,
    };

    this.getCollectionCenters(
      this.config.itemsPerPage,
      this.config.currentPage
    );
    this.route.queryParams.subscribe(
      (params) =>
        (this.config.currentPage = params["page"] ? params["page"] : 1)
    );
  }

  initialiseForm() {
    this.searchForm = this.formBuilder.group({
      center_name: [""],
      center_provinces: [""],
      //center_email: [""],
    });
  }

  logCenter() {
    console.log(JSON.stringify(this.map.getCenter()));
  }

  openInfo(marker: MapMarker, content) {
    this.infoContent = content;
    this.info.open(marker);
  }

  getCollectionCenters(pagesize, pageno) {
    this.apiUrl =
      environment.AUTHAPIURL + "collection-center-list?page=" + pageno;

    // const obj = {
    // 	per_page: 10,
    //   page_no: pageno
    // };

    this.searchObject["page_no"] = pageno;
    this.searchObject["per_page"] = pagesize;

    this.spinnerService.show();
    this.http.post<any>(this.apiUrl, this.searchObject).subscribe((data) => {
      console.log("collectionCenters: ", data);
      this.collectionCenters = data.response.data;
      this.config.totalItems = data.response.total;
      this.spinnerService.hide();
    });
  }

  pageChange(newPage: number) {
    console.log(newPage);
    this.collectionCenters = "";
    this.router.navigate(["/locate-store"], {
      queryParams: { page: newPage },
    });
    this.getCollectionCenters(this.config.itemsPerPage, newPage);
  }

  public setItemsPerPage(event) {
    this.config.itemsPerPage = event;
    this.currentPageLength = this.config.itemsPerPage;
    this.collectionCenters = "";
    this.router.navigate(["/locate-store"]);
    this.getCollectionCenters(this.config.itemsPerPage, 1);
  }

  onSubmitSearch(formAllData: any) {
    this.submitted = true;

    // stop the process here if form is invalid
    if (this.searchForm.invalid) {
      return;
    }

    this.searchObject = {
      name: formAllData.center_name,
      // phone: formAllData.center_phone,
      // email: formAllData.center_email,
    };

    console.log("searchFormData: ", this.searchObject);
    this.collectionCenters = "";
    this.getCollectionCenters(
      this.config.itemsPerPage,
      this.config.currentPage
    );
  }

  clearSearch() {
    this.collectionCenters = "";
    this.searchObject = {};
    this.initialiseForm();
    this.getCollectionCenters(
      this.config.itemsPerPage,
      this.config.currentPage
    );
  }

  isNumber(value: any): boolean {
    const newValue = Number(value);
    return newValue === 0 || newValue > 0;
  }
}
